<template>
  <div class="question-wrapper">
    <f7-block>
      <f7-block-header><span v-html="question.question"></span></f7-block-header>
      <span v-html="question.description"></span>
    </f7-block>
    <div class="answer-list">
      <f7-list inset>
        <f7-list-item radio
                      v-for="answer in question.answers"
                      :key="answer.id"
                      :name="question.id"
                      :id="question.id + answer.id"
                      :value="answer.value"
                      :checked="question.selectedAnswer === answer.id"
                      :ref="'answer' + question.id + answer.id"
                      @change="onAnswerChange($event.target, answer.id)"
                      @click="onAnswerClick($event.currentTarget, answer.id)">
          <div slot="title" v-html="answer.description"></div>
        </f7-list-item>
      </f7-list>
    </div>
    <f7-block v-if="question.hasErrors" class="error-message">
      Odgovor na to vprašanje je obvezen.
    </f7-block>
  </div>
</template>

<script>
export default {
  name: 'Question',
  props: ['question'],
  methods: {
    onAnswerChange: function (input, answerId) {
      if (input.checked) {
        this.$emit('answerSelected', answerId)
      }
    },
    onAnswerClick: function (target, answerId) {
      const input = this.$f7.$(target).find('input')[0]
      if (input !== undefined && input.checked) {
        this.$emit('answerSelected', answerId)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  div.question-wrapper /deep/ {

    .answer-list .item-title {
      text-after-overflow: none;
      white-space: initial;
    }

    .error-message {
      color: #d14;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/Question.vue